import HeaderCell from "components/table/HeaderCell";
import moment from "moment";

const columns = [
  {
    name: <HeaderCell label={"REQUEST ID"} />,
    selector: (row) => row?.id,
  },
  {
    name: <HeaderCell label={"BAGS ID"} />,
    selector: (row) => row?.bags?.map((item) => item?.id).join(", ") || "",
  },
  {
    name: <HeaderCell label={"WAY OF SENDING"} />,
    selector: (row) =>
      row?.type === "drop-at-location"
        ? "Drop At Location"
        : row?.type === "dhl"
        ? "DHL"
        : row?.type,
  },
  {
    name: <HeaderCell label={"LOCATION"} />,
    selector: (row) => row?.locationId?.name,
  },
  {
    name: <HeaderCell label={"CREATED DATE"} />,
    selector: (row) => {
      if (row.date_created) return moment(row.date_created).format("DD/M/YYYY");
      return "";
    },
  },
  {
    name: <HeaderCell label={"Tracking"} />,
    selector: (row) =>
      row?.type === "dhl" && row?.trackingUrl ? (
        <a
          href={row?.trackingUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#007bff",
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          Track
        </a>
      ) : (
        "-"
      ),
  },
  {
    name: <HeaderCell label={"ACTION"} />,
    selector: (row) => row.action,
    width: "120px",
  },
];

export { columns };
